import apiClient from "./axios"

const base = importerId => `/vehicle-importers/${importerId}/staffs`

export const getVehicleImporterStaffs = async (importerId, params = {}) => {
  const { data } = await apiClient.get(base(importerId), { params })
  return data
}

export const getVehicleImporterStaff = async (importerId, id) => {
  const { data } = await apiClient.get(`${base(importerId)}/${id}`)
  return data
}

export const createVehicleImporterStaff = async ({ importerId, ...payload }) => {
  const { data } = await apiClient.post(base(importerId), payload)
  return data
}

export const updateVehicleImporterStaff = async ({ importerId, id, ...payload }) => {
  const { data } = await apiClient.patch(`${base(importerId)}/${id}`, payload)
  return data
}

export const deleteVehicleImporterStaff = async (importerId, id) => {
  const { data } = await apiClient.delete(`${base(importerId)}/${id}`)
  return data
}
